import "../asset_cropper.js";

window.ThumbnailEditor = window.ThumbnailEditor || {}; // VITE_MIGRATION: ensure namespace exists before submodule assignment
ThumbnailEditor.Cropper = class Cropper {
  constructor(options) {
    this.render = this.render.bind(this);
    this.setImage = this.setImage.bind(this);
    this.getPreviewUrl = this.getPreviewUrl.bind(this);
    this._handleCropped = this._handleCropped.bind(this);
    this._build = this._build.bind(this);
    this._teardown = this._teardown.bind(this);
    this._triggerCropperReady = this._triggerCropperReady.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    if (options == null) {
      options = {};
    }
    this.options = options;
    this.el = jQuery('<div class="thumbnail-editor-cropper">');
  }

  render() {
    if (this.imageUrl != null) {
      this._build();
    } else {
      this._triggerCropperReady();
    }
    return this;
  }

  // DSL

  setImage(imageUrl, cropSettings) {
    this.imageUrl = imageUrl;
    this.cropSettings = cropSettings;
    this._teardown();
    return this.render();
  }

  getPreviewUrl() {
    if (this.assetCropper != null) {
      return this.assetCropper.getPreviewUrl();
    }
  }

  // CALLBACKS

  _handleCropped(cropSettings) {
    this.cropSettings = cropSettings;
    return this._triggerEvent("crop", cropSettings);
  }

  // HELPER FUNCTIONS

  _build() {
    this._teardown();
    const image = jQuery("<img>").attr("src", this.imageUrl).appendTo(this.el);
    const options = jQuery.extend(
      { onCrop: this._handleCropped, onReady: this._triggerCropperReady, fitCropToAspectRatio: true },
      this.options,
    );

    return (this.assetCropper = new Sparkle.AssetCropper(image.get(0), this.cropSettings, options));
  }

  _teardown() {
    if (this.assetCropper != null) {
      this.assetCropper.destroy();
      this.assetCropper = null;
      return this.el.empty();
    }
  }

  _triggerCropperReady() {
    return this._triggerEvent("ready");
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }
};
